import React from "react";
import "./LocationSection.scss";

export default function LocationSection() {
  return (
    <>
      <section className="location-section">
        <div className="container">
          {/* LEFT SIDE — INFO */}
          <div className="text-content">
            <div className="location-info">
              <h3 className="location-title">J & M Tech Solutions</h3>

              <p className="address">
                891, 7th Main Rd, Prakash Nagar, Rajajinagar,
                <br />
                Bengaluru, Karnataka 560021
              </p>

              <ul className="contact-list">
                <li>
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel:+919538777965">+91 9538777965</a>
                </li>
                <li>
                  <i className="fa-solid fa-envelope"></i>
                  <a href="mailto:info@jmtechsolutions.in">
                    jmtechsolution2024@gmail.com
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-globe"></i>
                  <a
                    href="https://jmtechsolutions.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.jmtechsolutions.in
                  </a>
                </li>
              </ul>

              <div className="timing">
                <h4>Office Hours</h4>
                <p>Mon – Sat: 10:00 AM – 6:30 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE — MAP */}
          <div className="map-section">
            <iframe
              title="J & M Tech Solutions Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15550.60974670738!2d77.557999!3d12.994068!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d8966a9d1db%3A0x816011e3efe36069!2s891%2C%207th%20Main%20Rd%2C%20Prakash%20Nagar%2C%20Rajajinagar%2C%20Bengaluru%2C%20Karnataka%20560021!5e0!3m2!1sen!2sus!4v1762698245618!5m2!1sen!2sus"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
}
